<template>
  <v-form
    ref="suppliersForm"
    @submit.prevent=""
    :value="valid"
    @input="v => $emit('update:valid', v)"
  >
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="name_fournisseur"
          @change="v => $emit('update:name_fournisseur', v)"
          label="Nom"
          prepend-icon="fa-building"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="country"
          @change="v => $emit('update:country', v)"
          label="Pays"
          prepend-icon="fa-globe-americas"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="road"
          @change="v => $emit('update:road', v)"
          label="Numéro de rue"
          prepend-icon="fa-mail-bulk"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="city"
          @change="v => $emit('update:city', v)"
          label="Ville"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="postal_code"
          @change="v => $emit('update:postal_code', v)"
          label="Code Postal"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" md="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="telephone"
          @change="v => $emit('update:telephone', v)"
          mask="phone"
          label="Téléphone"
          prepend-icon="fa-phone"
        ></v-text-field>
      </v-col>
      <v-col cols="2" md="2">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="poste"
          @change="v => $emit('update:poste', v)"
          label="Poste"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="courriel"
          @change="v => $emit('update:courriel', v)"
          label="Courriel"
          prepend-icon="fa-at"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-textarea
          filled
          dense
          class="no-before"
          :value="comments"
          @change="v => $emit('update:comments', v)"
          label="Commentaires"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "SuppliersFields",
  props: {
    name_fournisseur: {
      required: true
    },
    country: {
      required: true
    },
    postal_code: {
      required: true
    },
    road: {
      required: true
    },
    city: {
      required: true
    },
    courriel: {
      required: true
    },
    telephone: {
      required: true
    },
    poste: {
      required: true
    },
    comments: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    reset() {
      this.$refs.suppliersForm.reset();
    }
  }
};
</script>

<style lang="scss" scoped></style>
